module.exports = __webpack_public_path__ + "assets/img/wash-text.9ae887b5.png";